<template>
  <el-table :data="planDataList" border style="width: 100%" ref="table">
    <el-table-column
      type="index"
      width="50"
      label="行号"
      header-align="center"
      align="center"
    ></el-table-column>
    <el-table-column label="品番号" align="center">
      <template slot-scope="scope">
        {{ scope.row.code }}
      </template>
    </el-table-column>
    <el-table-column label="产品名称" align="center">
      <template slot-scope="scope">
        {{ $productName(scope.row) }}
      </template>
    </el-table-column>
    <el-table-column
      label="合同数量"
      header-align="center"
      align="center"
      width="120"
    >
      <template slot-scope="scope">
        {{ scope.row.agreementCount }}
      </template>
    </el-table-column>
    <el-table-column
      v-for="(column, index) in planList"
      :key="index"
      :label="column"
      header-align="center"
      align="center"
      width="160"
    >
      <template slot-scope="scope">
        {{ scope.row[column] }}
      </template>
    </el-table-column>
    <el-table-column
      label="剩余数量"
      header-align="center"
      align="center"
      width="160"
      fixed="right"
    >
      <template slot-scope="scope">
        <el-tag :type="scope.row.limitCount > 0 ? 'danger' : 'success'">{{
          scope.row.limitCount
        }}</el-tag>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import BigNumber from "bignumber.js";

export default {
  components: {},
  props: {
    dataList: {
      type: Array,
      default: ()=>{
          return []
      },
    },
  },
  data() {
    return {
      tblHeight: 300,
      planList: [],
      planDataList: [],
    };
  },
  watch: {
    dataList: {
      handler: function (newVal) {
        if (!newVal || newVal.length === 0) {
          this.planList = [];
          this.planDataList = [];
        } else {
          this.convertDataList();
        }
      },
      immediate: true,
    },
  },
  mounted() {},
  activated() {},
  methods: {
    convertDataList() {
      let tmp = [];
      this.dataList.forEach((item) => {
        let row = tmp.find((m) => m.id === item.agreementDetailId);
        let sendDate = item.sendDate;
        let count = item.count;
        if (!row) {
          row = {
            ...item,
            id: item.agreementDetailId,
            limitCount:0
          };
          delete row.agreementDetailId;
          delete row.sendDate;
          delete row.count;
          tmp.push(row);
        }
        this.addPlan(sendDate);
        row[sendDate] = count;
      });
      this.reComputedLimitCount(tmp)
      this.planDataList=tmp
    },
    addPlan(item) {
      if (this.planList.find((p) => p === item)) {
        return;
      }
      this.planList.push(item);
    },
    reComputedLimitCount(dataList) {
      dataList.forEach((row) => {
        let sendCount = new BigNumber(0);
        this.planList.forEach((plan) => {
          if (!row[plan]) {
            return;
          }
          let tc = new BigNumber(row[plan]);
          if (!tc.isInteger) {
            return;
          }
          sendCount = sendCount.plus(tc);
        });
        row.limitCount = row.agreementCount - sendCount.toNumber();
      });
    },
  },
};
</script>
